import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';

import { GlobalCustomField } from 'src/models';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';
import { ProjectsService } from 'src/services/projects.service';

import { CustomFieldsModule } from '../custom-fields/custom-fields.module';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, CustomFieldsModule],
  selector: 'app-edit-global-fields',
  templateUrl: './edit-global-fields.component.html',
  styleUrls: ['./edit-global-fields.component.scss'],
})
export class EditGlobalFieldsComponent implements OnInit {
  isLoading = false;
  fields: GlobalCustomField[] = [];
  projectId: string;
  readOnly: boolean = true;
  constructor(
    private modalCtrl: ModalController,
    private route: ActivatedRoute,
    private projectsService: ProjectsService,
    private authService: AuthService,
    private msgSrvc: MessageService,
  ) {
    this.projectId = this.route.snapshot.params['projectId'];
  }

  async ngOnInit(): Promise<void> {
    try {
      this.isLoading = true;
      this.readOnly = !this.authService.isProjectOwner(this.projectId);
      await this.loadGlobalFields();
    } catch (error) {
      this.modalCtrl.dismiss();
    } finally {
      this.isLoading = false;
    }
  }

  async loadGlobalFields() {
    const result = await this.projectsService.getById(this.projectId);
    this.fields = result.fields || [];
  }
  dismiss() {
    this.modalCtrl.dismiss();
  }

  async submit() {
    const transformedFields = this.fields.map((field) => {
      return {
        id: field.id,
        public: field.public,
        required: field.required,
        conditions: field.conditions,
      };
    });

    try {
      await this.projectsService.updateCustomFields(this.projectId, { fields: transformedFields });
      await this.msgSrvc.show('Global custom fields updated!');
      this.modalCtrl.dismiss();
    } catch (error) {
      this.msgSrvc.showError(error);
    }
  }
}
